/**
 * Set `aria-live` manually here as we cannot use Swiper's navigation since we use custom arrows.
 */
export function setAriaLive(el: HTMLElement | null, initialValue = '') {
  const value = initialValue.trim();
  if (!el || !value) return;

  el.innerHTML = '';

  setTimeout(() => {
    el.innerHTML = `<div aria-live="polite" aria-atomic="true" class="visually-hidden">${value}</div>`;
  }, 100);
}
